import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FileList.css';
import { AuthContext } from '../../../../authContext';
import AlertsCustom from '../../../../components/Alerts/index'

function FileList({ files }) {
  const { t: tDatabase } = useTranslation('database');
  const { t: tCommon } = useTranslation('common');
  const lastFile = files[files.length - 1];
  const { accessToken } = useContext(AuthContext);
  const [isDownloading, setIsDownloading] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const downloadFile = async () => {
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/download?filename=${encodeURIComponent(lastFile)}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });

      if (!response.ok) {
        console.error('Erro ao baixar o arquivo', response.status);
        //alert('Erro ao baixar o arquivo.');
        setAlertTitle(tCommon('alertErrorTitle'));
        setAlertType("error")
        setAlertMessage(tDatabase('download_erro'))
        setShowAlert(true);
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = lastFile;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao fazer o download do arquivo:', error);
      setAlertTitle(tCommon('alertErrorTitle'));
      setAlertType("error")
      setAlertMessage(tDatabase('download_erro'))
      setShowAlert(true);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className='list'>
      {showAlert && (
        <AlertsCustom
          type={alertType}
          title={alertTitle}
          message={alertMessage}
          onClose={() => setShowAlert(false)}
        />
      )}
      <div style={{ marginLeft: '0.8rem' }}>
        <div className='titulo_adicionada'>
          <strong>{tDatabase('last_minutes_added')}</strong>
        </div>

        {files.length > 0 ? (
          <ul className="file-list">
            <li key={lastFile} title={lastFile} style={{ display: 'flex', alignItems: 'center' }}>
              {lastFile.length > 60 ? `${lastFile.slice(0, 60)}...` : lastFile}

              {isDownloading ? (
                <span style={{ marginLeft: '0.5rem', fontSize: '0.9rem', color: '#555' }}>
                  {tCommon('downloading')}
                </span>
              ) : (
                <img
                  src="/imagens/download.svg"
                  alt={tCommon('downloadIcon')}
                  style={{ cursor: 'pointer', width: '20px', height: '20px', marginLeft: '0.5rem' }}
                  onClick={downloadFile}
                />
              )}
            </li>
          </ul>
        ) : (
          <span className="no-files">{tDatabase('no_documents_added')}</span>
        )}
      </div>
    </div>
  );
}

export default FileList;
